import { ViewEditModeContextProvider } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { RoomFormContainer } from '../Common/RoomFormContainer';

export const ModernRoomDetail = () => {
  return (
    <ViewEditModeContextProvider>
      <RoomFormContainer />
    </ViewEditModeContextProvider>
  );
};
